import { MayBeNull } from './common'

export interface AnalyticsEvent {
  action: string
  params: AnalyticsEventParam[]
}

export interface AnalyticsPageEvent {
  pageTitle: string
  previousUrl: string
  pageUrl: string
}

export interface AnalyticsEventParam {
  key: string
  value: string | boolean | CustomAnalyticsEventParam[] | []
}

export interface CustomAnalyticsEventParam {
  levelCategory?: MayBeNull<string>
  levelValue?: MayBeNull<string>
}

export enum AnalyticsActionType {
  action = 'Action',
  page = 'Page',
}

export enum SourceLocations {
  Core = 'CORE',
  Orchestration = 'ORCHESTRATION',
}

export interface AnalyticsActionBase<T extends AnalyticsActionType, P> {
  type: T
  payload: P
}

export type AnalyticsPageActionPayload = string | AnalyticsPageEvent
export type AnalyticsPageAction = AnalyticsActionBase<AnalyticsActionType.page, AnalyticsPageActionPayload>
export type AnalyticsTrackActionPayload = string | AnalyticsEvent
export type AnalyticsTrackAction = AnalyticsActionBase<AnalyticsActionType.action, AnalyticsTrackActionPayload>
export type AnalyticsAction = AnalyticsPageAction | AnalyticsTrackAction
